// Input component translations
export default {
  // Placeholder texts
  placeholders: {
    email: "Enter email address",
    password: "Enter password",
    phone: "Enter phone number",
    name: "Enter name",
    username: "Enter username",
    search: "Enter search keywords",
    title: "Enter title",
    content: "Enter content",
    description: "Enter description",
    remark: "Enter remark",
    url: "Enter URL",
    amount: "Enter amount",
    quantity: "Enter quantity",
    date: "Select date",
    time: "Select time",
  },

  // Validation messages
  validation: {
    required: "This field is required",
    emailFormat: "Please enter a valid email format",
    phoneFormat: "Please enter a valid phone number format",
    urlFormat: "Please enter a valid URL format",
    numberFormat: "Please enter a valid number",
    minLength: "Minimum {min} characters required",
    maxLength: "Maximum {max} characters allowed",
    minValue: "Minimum value is {min}",
    maxValue: "Maximum value is {max}",
    pattern: "Invalid format",
    unique: "This value already exists",
    confirm: "Input does not match",
  },

  // Action hints
  clear: "Clear",
  show: "Show",
  hide: "Hide",
  copy: "Copy",
  paste: "Paste",
  select: "Select",
  browse: "Browse",

  // Status texts
  readonly: "Read-only",
  disabled: "Disabled",
  optional: "Optional",
  required: "Required",

  // File upload
  upload: {
    selectFile: "Select File",
    dragDrop: "Drag and drop files here or",
    fileSize: "File size cannot exceed {size}",
    fileType: "Supported file types: {types}",
    uploadSuccess: "Upload successful",
    uploadFailed: "Upload failed",
    uploading: "Uploading...",
  },
};
